export default "__VITE_ASSET__wgkSMnTU__"